import React from 'react'
import styled from 'styled-components'
import { Redirect } from 'react-static'

import AdminCreateListen from './AdminCreateListen'
import AdminSuccess from './AdminSuccess'

const Wrapper = styled.div`
  .title.is-3 {
    margin-bottom: 1em;
  }

  .title.is-5 {
    font-weight: 400;
  }

  .title-input {
    max-width: 15em;
  }

  .admin-create-cats select {
    text-transform: capitalize;
  }

  .coverimage.box {
    max-width: 400px;
    margin-bottom: 0;
    box-shadow: none;
    border: 1px solid #ccc;

    img {
      width: 100%;
      height: auto;
      padding: 0 0 0.5em;
    }

    &.is-danger {
      background-color: #fff;
      border-color: #ff486a;
    }
  }
`

export default class AdminCreate extends React.Component {
  constructor() {
    super()
    this.state = {
      success: false,
      successRedirect: false,
      successRedirectUrl: '',
    }
    this.errorClass = this.errorClass.bind(this)
    this.showSuccessModal = this.showSuccessModal.bind(this)
    this.successRedirect = this.successRedirect.bind(this)
  }
  renderTemplate(components) {
    const { template, data } = this.props
    const Template = components[template]
    return (
      <Template
        data={data}
        errorClass={this.errorClass}
        showSuccessModal={this.showSuccessModal}
        successRedirect={this.successRedirect}
      />
    )
  }
  showSuccessModal(cb, url) {
    this.setState({ success: true }, () => {
      cb(url)
    })
  }
  successRedirect(url) {
    setTimeout(() => {
      this.setState({
        successRedirect: true,
        successRedirectUrl: url,
      })
    }, 800)
  }
  errorClass(bool) {
    return !bool ? 'is-danger' : ''
  }
  render() {
    const components = {
      listen: AdminCreateListen,
    }
    const { success, successRedirect, successRedirectUrl } = this.state
    return successRedirect ? (
      <Redirect to={`/admin/${successRedirectUrl}`} />
    ) : (
      <Wrapper className="admin-create">
        {this.renderTemplate(components)}
        <AdminSuccess type="Creation" className={success ? 'modal is-active' : 'modal'} />
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/admin/AdminCreate.js